/**
 * Best-effort message from axios-style errors.
 * For Media Devoted | Created By Ciro Autiero
 */

export function readHttpErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const r = (err as { response?: { data?: { message?: unknown } } })
      .response;
    const m = r?.data?.message;
    if (typeof m === 'string') return m;
  }
  return 'Request failed';
}
